export default "__VITE_ASSET__BO5ZlE1u__"